var f = Object.defineProperty;
var g = (s, e, t) => e in s ? f(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var r = (s, e, t) => g(s, typeof e != "symbol" ? e + "" : e, t);
const c = {}, p = [
  "debug",
  "log",
  "info",
  "warn",
  "error"
], l = Symbol.for("@launchdarkly/o11y.sdkLogger"), h = (() => {
  try {
    return (c == null ? void 0 : c.DEBUG) === "true";
  } catch (s) {
    return !1;
  }
})(), a = (() => {
  var t;
  const s = globalThis, e = (t = s[l]) != null ? t : s[l] = {
    debugEnabled: !1,
    suppressDepth: 0
  };
  return h && (e.debugEnabled = !0), e;
})(), x = (s) => {
  a.debugEnabled = s;
}, b = () => a.debugEnabled, E = () => a.suppressDepth > 0, i = (s) => {
  a.suppressDepth++;
  try {
    return s();
  } finally {
    a.suppressDepth--;
  }
}, y = (s) => p.includes(s) ? s : "log", _ = (s, ...e) => {
  a.debugEnabled && i(() => {
    var t;
    try {
      ((t = console[y(s)]) != null ? t : console.log).apply(console, e);
    } catch (o) {
    }
  });
}, d = /* @__PURE__ */ Object.create(null), n = (s, e, ...t) => {
  const o = `[@launchdarkly plugins]: (${s}): `;
  _(e, o, ...t);
}, D = (s, e, t, ...o) => {
  d[`${s}-${e}`] || (d[`${s}-${e}`] = !0, n(s, t, ...o));
};
class L {
  constructor(e, t) {
    r(this, "debug");
    r(this, "name");
    this.debug = e, this.name = t;
  }
  prefix() {
    let e = `[${Date.now()}]`;
    return this.name && (e += ` - ${this.name}`), e;
  }
  log(...e) {
    this.debug && i(
      () => console.log.apply(console, [this.prefix(), ...e])
    );
  }
  warn(...e) {
    (this.debug || b()) && i(
      () => console.warn.apply(console, [this.prefix(), ...e])
    );
  }
}
class $ {
  constructor() {
    r(this, "_sdk");
    r(this, "_isLoaded", !1);
    r(this, "_callBuffer", []);
    r(this, "_capacity", 1e5);
    r(this, "_droppedEvents", 0);
    r(this, "_exceededCapacity", !1);
    r(this, "_logger", new L());
  }
  _bufferCall(e, t) {
    if (this._isLoaded)
      try {
        return this._sdk[e](...t);
      } catch (o) {
        n(
          `Error executing buffered call to ${e}:`,
          "error",
          o
        );
      }
    else {
      this._enqueue({ method: e, args: t });
      return;
    }
  }
  _enqueue(e) {
    this._callBuffer.length < this._capacity ? (this._callBuffer.push(e), this._exceededCapacity = !1) : (this._exceededCapacity || (this._exceededCapacity = !0, n(
      "Exceeded event queue capacity. Increase capacity to avoid dropping events.",
      "warn"
    )), this._droppedEvents += 1);
  }
  load(e) {
    this._sdk = e, this._isLoaded = !0;
    for (const { method: t, args: o } of this._callBuffer)
      try {
        this._sdk[t](...o);
      } catch (u) {
        n(
          `Error executing buffered call to ${t}:`,
          "error",
          u
        );
      }
    this._callBuffer = [];
  }
}
export {
  $ as B,
  L,
  _ as a,
  E as b,
  b as c,
  D as d,
  n as i,
  x as s
};
//# sourceMappingURL=buffer-BjzLorpP.js.map
